import { Box, makeStyles, Typography } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

import completeIcon from "../../../../../assets/image/settings_v2/complete.svg";
import { SettingItemsProps } from "../../SettingsPage";
import { getProfileCompletionFromUser, ProfileSection } from "../../utils/profileCompletion";
import { profileSectionTitles } from "../../utils/profileFields";
import { ProfileEditor } from "../ProfileEditor";
import { SettingsCard } from "../SettingsCard";
import { useSettingsContentStyles } from "../SettingsContent";

const useStyles = makeStyles({ identifier: { backgroundColor: theme.palette.semantic["surface/card"] } });
export const BasicInfo: React.FC<SettingItemsProps> = (props) => {
  const classes = useSettingsContentStyles();
  const styles = useStyles();
  const [section, setSection] = React.useState<ProfileSection | null>(null);
  const backToHub = React.useCallback(() => setSection(null), []);
  React.useEffect(() => {
    if (!section) props.onHeaderChange?.("基本情報", props.onBack);
  }, [section, props.onHeaderChange, props.onBack]);
  if (section) return <ProfileEditor {...props} section={section} onBack={backToHub} />;
  const completion = getProfileCompletionFromUser(props.user);
  const descriptions = {
    personal: "名前・生年月・連絡先・お住まい",
    financial: "ご職業・年収・資産・保有物件",
    investment: "検討の時期・面談の回数・希望条件",
  };
  return (
    <Box className={classes.stack}>
      <Box display="flex" flexDirection="column" style={{ gap: 8 }}>
        {(["personal", "financial", "investment"] as ProfileSection[]).map((key) => (
          <SettingsCard
            key={key}
            label={profileSectionTitles[key]}
            description={descriptions[key]}
            trailing={
              completion.sections[key].remaining ? (
                <Typography className={classes.caption} style={{ whiteSpace: "nowrap" }}>
                  あと{completion.sections[key].remaining}項目
                </Typography>
              ) : (
                <img src={completeIcon} width={16} height={16} alt="入力済み" />
              )
            }
            onClick={() => setSection(key)}
          />
        ))}
      </Box>
      <Box className={`${classes.note} ${styles.identifier}`}>
        <Box display="flex" justifyContent="space-between">
          <Typography className={classes.caption}>ID</Typography>
          <Typography className={classes.address}>{props.user.identifier}</Typography>
        </Box>
        <Typography className={classes.caption}>お問い合わせのときに使います。変更はできません。</Typography>
      </Box>
    </Box>
  );
};
